import { buildJson } from "./payload.helper";

const contactsHelper = {
  forSend: ({ name, email, subject, message }) =>
    buildJson({
      name,
      email: email?.trim().toLowerCase(),
      subject,
      message,
    }),
  forReply: (id, { reply_message }) => ({
    id,
    body: buildJson({ reply_message }),
  }),
};

export default contactsHelper;
